import classNames from "classnames/bind";
import UIIcon from "common/blocks/UIIcon";
import SmartLink from "common/wrapper/SmartLink";
import { useFavouritesContext } from "features/favourites/hooks/useFavouritesContext";
import useHasMounted from "hooks/useHasMounted/useHasMounted";
import getPathByType, { UrlPathTypes } from "utils/getPathByType";

import styles from "./HeaderShortListButton.module.scss";

const cx = classNames.bind(styles);

type HeaderShortListButtonProps = {
    prefetch?: boolean;
};

const HeaderShortListButton: React.FC<HeaderShortListButtonProps> = ({ prefetch = false }) => {
    const {
        userContext: { userContext },
    } = useFavouritesContext();

    const { savedSearchesCount = 0, shortlistCount = 0 } = userContext?.savedDataMeta || {};
    const totalCount = savedSearchesCount + shortlistCount;

    const hrefType = shortlistCount
        ? UrlPathTypes.ShortlistPage
        : savedSearchesCount
          ? UrlPathTypes.SavedSearches
          : UrlPathTypes.ShortlistPage;

    return (
        <SmartLink href={getPathByType({ type: hrefType })} prefetch={!!prefetch}>
            <a className={cx("buttonWrapper")} aria-label="Shortlist">
                <div
                    className={cx({
                        shortlistBaseIcon: true,
                        shortlistButton: !!totalCount,
                    })}
                >
                    <span className={cx("heartIconWrapper")}>
                        <UIIcon className={cx("heartIcon")} icon="Heart" />
                    </span>
                    {!!totalCount && <span className={cx("shortlistValue")}>{totalCount}</span>}
                </div>
            </a>
        </SmartLink>
    );
};

export default HeaderShortListButton;
